import AutocompleteComponent from 'components/design-system/Autocomplete/Autocomplete';
import Heading from 'components/design-system/Heading/Heading';
import InputComponent from 'components/design-system/input/Input';
import LabelComponent from 'components/design-system/Label/Label';
import { TooltipComponent } from 'components/design-system/Tooltip/Tooltip';
import CheckboxComponent from 'components/design-system/Checkbox/Checkbox';
import { useState } from 'react';
import { CircularProgress, InputAdornment, Typography } from '@mui/material';

const CamposGrupos = ({
  // Formik
  errors,
  handleBlur,
  handleChange,
  handleReset,
  handleSubmit,
  isSubmitting,
  setFieldError,
  setFieldTouched,
  setFieldValue,
  touched,
  validateForm,
  values,
  tipoForm,

  // Dependencias
  permisos,
  isLoadingPermisos,
  // Empresas
  empresas,
  isLoadingEmpresas,
  validating
}) => {
  const [originalNombreGrupoValue, setOriginalNombreGrupoValue] = useState('');

  return (
    <div className="col-span-12">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 md:col-span-12">
          <Heading type="h4" className="mb-0">
            Grupos de negocios
          </Heading>
        </div>
        <div className="col-span-12 xs:col-span-12 mb-12">
          <div className="grid grid-cols-12 gap-4">
            {/* nombreGrupo */}
            <div className="col-span-12">
              <InputComponent
                autoComplete="off"
                disabled={validating || isSubmitting}
                textFieldParams={{
                  InputProps: {
                    readOnly: validating,
                    endAdornment: validating && (
                      <InputAdornment position="end">
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8
                          }}
                        >
                          <Typography variant="caption">
                            Validando nombre ...
                          </Typography>
                          <CircularProgress size={20} />
                        </div>
                      </InputAdornment>
                    )
                  }
                }}
                name={'nombreGrupo'}
                value={values.nombreGrupo}
                fullWidth
                onChange={e => {
                  setFieldValue('modificadoEmpresas', false);
                  setFieldTouched('nombreGrupo', true);
                  const nombreGrupo = e.target.value;
                  setFieldValue('nombreGrupo', nombreGrupo);
                }}
                onPaste={handleChange}
                onBlur={e => {
                  const nombreGrupo = e.target.value;
                  setFieldValue('nombreGrupo', nombreGrupo);
                  setFieldValue(
                    'nombreModificado',
                    originalNombreGrupoValue !== nombreGrupo
                  );
                }}
                onFocus={e => {
                  setOriginalNombreGrupoValue(e.target.value);
                }}
                touched={touched.nombreGrupo}
                placeholder=""
                estado={
                  errors.nombreGrupo && !validating
                    ? { tipo: 'error', mensaje: errors.nombreGrupo }
                    : null
                }
                label={
                  <LabelComponent className="w-full">
                    Nombre <br />
                    {/* <span className="text-neutral-60">(opcional)</span> */}
                    <TooltipComponent
                      className="float-right"
                      title={''}
                    ></TooltipComponent>
                  </LabelComponent>
                }
              />
            </div>
            {/* Empresas / Negocio */}
            <div className="col-span-12">
              <AutocompleteComponent
                id="empresas"
                disableCloseOnSelect
                clearOnEscape={true}
                disabled={isSubmitting || isLoadingEmpresas} // || isLoadingEmpresas}
                fullWidth
                limitTags={4}
                multiple
                name={'empresas'}
                options={empresas || []}
                value={values.empresas || []}
                onChange={(ev, empresaSelected, reason) => {
                  if (!empresaSelected) return;
                  setFieldValue('modificadoEmpresas', true);
                  let data = {
                    name: 'empresas',
                    value: empresaSelected || []
                  };
                  if (reason === 'clear') {
                    data.value = [];
                    return setFieldValue('empresas', data.value);
                  }
                  setFieldValue('empresas', data.value);
                }}
                onBlur={handleBlur}
                getOptionSelected={(option, value) =>
                  option.nombreEmpresa === value.nombreEmpresa
                }
                accesor="nombreEmpresa"
                getOptionLabel={option => option.nombreEmpresa || ''}
                noOptionsText={
                  isLoadingPermisos ? 'Cargando...' : 'Sin opciones'
                }
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <CheckboxComponent
                      size="small"
                      className="py-1"
                      checked={selected}
                    />
                    {option.nombreEmpresa}
                  </li>
                )}
              >
                <InputComponent
                  autoComplete="off"
                  disabled={isSubmitting} //|| isLoadingEmpresas}
                  fullWidth
                  touched={touched.empresas}
                  estado={
                    errors.empresas
                      ? { tipo: 'error', mensaje: errors.empresas }
                      : null
                  }
                  label={<LabelComponent>Negocios</LabelComponent>}
                />
              </AutocompleteComponent>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CamposGrupos;
